import React from "react";

import SettingsTabs from "superAdminViews/setting/SettingsTabs";
import AttributeGroups from "./AttributeGroups";
import Attributes from "./Attributes";
import Categories from "./Categories";

const TABS = [
  { path: "/categories", label: "Categories", component: Categories },
  { path: "/attributeGroups", label: "Attribute groups", component: AttributeGroups },
  { path: "/attributes", label: "Attributes", component: Attributes },
];

/**
 * ProductOptions - how shops classify and describe what they sell.
 */
const ProductOptions = () => (
  <SettingsTabs
    title="Product options"
    description="The categories and attributes shops tag their products with."
    base="/superAdmin/type&cuisine"
    tabs={TABS}
  />
);

export default ProductOptions;
